import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { BrowserRouter as Router } from "react-router-dom";

import {Drawer, AppBar, CssBaseline, Divider, IconButton} from '@material-ui/core';
import {ChevronLeft, ChevronRight, Menu} from '@material-ui/icons';

import {NavigationItems, NavigationMain, NavigationToolbar} from "./Navigation.jsx";
import {getCurrentUser} from "../store/entities/currentUserSlice";
import Selector from "./Selectors/Drawer/Selector";
import clsx from 'clsx';

const drawerWidth = 240;

export default function() {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const currentUser = useSelector(getCurrentUser);
    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => {setOpen(false)
      console.log('close')

    };

    return <Router>
        <div className={classes.root}>
            <CssBaseline />

            {/* top navigation bar */}
            <AppBar
                color="primary"
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <NavigationToolbar menuOpener={
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: open,
                        })}
                    >
                        <Menu />
                    </IconButton>
                } />
            </AppBar>

            {/* top navigation drawer */}
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx(classes.drawerPaper, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
                    </IconButton>
                </div>
                <Divider />
                <NavigationItems onClick={handleDrawerClose} currentUser={currentUser} />
            </Drawer>

            {/* main content */}
            <main
                className={classes.content}
            >
                <div
                    className={classes.contentOverlay}
                >
                    <div className={classes.toolbar} />
                    <NavigationMain/>
                </div>
            </main>

            <Selector />
        </div>
    </Router>;
}



// style of the layout
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawerPaper: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,

        //borderBottom: '1px solid black',
        height: '100%',
        //minHeight: window.innerHeight,
        //backgroundImage: 'url("/img/ancient-antique-architectural-design.jpg")',
        //backgroundImage: 'url("img/art-design-gallery.jpg")',
        //backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
    },
    contentOverlay: {
        padding: theme.spacing(2),
        //minHeight: window.innerHeight,
        //height: '100%',
        //backgroundColor: 'black',
        //opacity: 0.8
    }
}));
